module.exports = __webpack_public_path__ + "img/nt.e505e8d7.jpg";